var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.281,
    height: 13.999,
    viewBox: "0 0 20.281 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_13057",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 13057",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_3",
    "data-name": "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435 3",
    d: "M3,13.67Q1.654,12.223.322,10.77a1.077,1.077,0,0,1,0-1.535Q1.655,7.778,3,6.334A.878.878,0,0,1,4.344,6.3,1.063,1.063,0,0,1,4.3,7.758c-.32.35-.645.7-.965,1.041-.051.053-.092.109-.176.207H13.719a.945.945,0,0,1,1.023.877,1.051,1.051,0,0,1-.191.736.9.9,0,0,1-.615.369c-.1.01-.2.01-.3.01H3.156c.082.1.125.15.172.205.328.352.658.7.98,1.057a1.06,1.06,0,0,1,.035,1.445A.866.866,0,0,1,3.7,14,.961.961,0,0,1,3,13.67ZM15.938,7.707a1.063,1.063,0,0,1,.051-1.461c.316-.354.641-.7.967-1.041.045-.053.09-.109.172-.207H6.563a.944.944,0,0,1-1.023-.877,1.052,1.052,0,0,1,.189-.736.905.905,0,0,1,.615-.369c.1-.01.2-.008.3-.008H17.121c-.072-.09-.109-.143-.152-.187-.326-.354-.656-.7-.98-1.059A1.065,1.065,0,0,1,15.938.3a.879.879,0,0,1,1.35.033q1.345,1.456,2.689,2.918a1.08,1.08,0,0,1,0,1.5q-1.342,1.462-2.689,2.916a.972.972,0,0,1-.705.334A.862.862,0,0,1,15.938,7.707Z",
    fill: "#2b2b2b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.9aff04f0bc6eaf1b7a20d80228ee48c2.svg";
export { ForwardRef as ReactComponent };